import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {RemoteAccessReasonsActions} from '../store';
import {RemoteAccessReasonsSelectors} from '../store/selectors';

@Injectable()
export class RemoteAccessReasonsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadRemoteAccessReasonsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadRemoteAccessReasonsDone() {
    return this.store.pipe(
      select(RemoteAccessReasonsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(RemoteAccessReasonsActions.ReadRemoteAccessReasons());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
